import { isSupplyMonitoringEventsEnabled } from 'common/js/supply-monitoring-events-enabling';
import { ConfigStore } from '../config.store';
import { FrameLifecycleHandler } from './frame-lifecycle-handler';
import { HeavyAdHandler } from './heavy-ad-handler';

export function getMwebSupplyEventsHandlers() {
  const formatConfig = ConfigStore.getInstance().config;
  if (!isSupplyMonitoringEventsEnabled(formatConfig)) return [];

  return [FrameLifecycleHandler, HeavyAdHandler];
}
